import React, { Component } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { onAuthStateChanged, sendEmailVerification, signOut } from 'firebase/auth';
import { authRef } from '../reference';

// HOC to inject navigate function
function withNavigate(Component) {
  return function WrappedComponent(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}

class Home extends Component {
  state = {
    emailSent: false,
    user: null,
  }

  componentDidMount() {
    this.unsubscribe = onAuthStateChanged(authRef, user => {
      if (!user) {
        this.props.navigate('/');
      } else {
        this.setState({ user });
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  handleSendEmailVerification = () => {
    if (authRef.currentUser) {
      sendEmailVerification(authRef.currentUser)
        .then(() => {
          this.setState({ emailSent: true });
        });
    }
  }

  handleSignOut = () => {
    signOut(authRef)
      .then(() => {
        this.props.navigate('/');
      });
  }

  render() {
    const { emailSent, user } = this.state;

    const email = user ? user.email : null;
    const emailVerified = user ? user.emailVerified : null;
    const sendEmail = emailSent
      ? <div className="success">Verification email sent!</div>
      : (<button onClick={this.handleSendEmailVerification}>
          SEND VERIFICATION EMAIL
      </button>);

    return (
      <div className="Home">

        <div className="Home-section">
          Email: {email}
        </div>

        <div className="Home-section">
          {emailVerified
            ? <div>Your email is verified!</div>
            : sendEmail}
        </div>

        <div className="Home-section">
          <Link to="/home/update-email">Update Email</Link>
        </div>

        <div className="Home-section">
          <Link to="/home/update-password">Update Password</Link>
        </div>

        <div className="Home-section">
          <button onClick={this.handleSignOut}>SIGN OUT</button>
        </div>

      </div>
    );
  }
}

export default withNavigate(Home);
